// extracted by mini-css-extract-plugin
export default {"side_panel":"SidePanel_side_panel__eQ61w","side_panel_item":"SidePanel_side_panel_item__R9Ycc","container":"SidePanel_container__2YFA9"};